// Client of "My Connected Sellers" (Provider Center). Same conventions as wholesaleService: plain JSON, never throws.
import { dsApi } from "./wholesaleService";

const qs = (params = {}) => {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => v !== undefined && v !== "" && v !== null && q.set(k, v));
  const s = q.toString();
  return s ? `?${s}` : "";
};

export const listConnectedSellers = (token, params) => dsApi(token, "GET", `/provider/connected-sellers${qs(params)}`);
export const listConnectedSellerProducts = (token, sellerId, params) =>
  dsApi(token, "GET", `/provider/connected-sellers/${encodeURIComponent(sellerId)}/products${qs(params)}`);
